// PWAとして実行している場合、外部リンクおよび登録関連のリンクはPWA外で開きたいので、 target="_blank" を設定する
window.addEventListener('DOMContentLoaded', () => {
  const isStandalone = () =>
    window.matchMedia('(display-mode: standalone)').matches;

  if (!isStandalone()) {
    return;
  }

  const entryFormPaths = ['/my/learners/new', '/registration', '/upgrade'];

  const isExternal = (url: URL) => url.origin !== document.location.origin;
  const isEntryForm = (url: URL) =>
    entryFormPaths.some((path) => url.pathname.startsWith(path));
  const shouldBeTargetBlank = (url: URL) => isExternal(url) || isEntryForm(url);
  const setTargetBlank = (link: HTMLAnchorElement) => (link.target = '_blank');

  const links = Array.from(
    document.querySelectorAll<HTMLAnchorElement>(
      'a[href]:not([target="_blank"]):not([data-method])',
    ),
  );
  const base = new URL(document.location.href);
  links
    .filter((link) => shouldBeTargetBlank(new URL(link.href, base)))
    .forEach(setTargetBlank);
});
